import React from 'react';
import { useParams } from 'react-router-dom';
import SettingsNavigator from './SettingsNavigator';
import SettingsContent from './SettingsContent';
import './Settings.css';
import { FaCog } from 'react-icons/fa';
import IconHeading from '../../components/sectionHeading/IconHeading';

export function Settings() {
    const { setting } = useParams();

    return (
        <>
        <div id="content-container">
                <IconHeading icon={FaCog} title="Settings" headingSize="medium" />
            <hr />
            <div className="settings-page">
                <SettingsNavigator />
                <SettingsContent selectedSetting={setting} />
            </div>
        </div>
        </>
    );
};

